/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListRiskExclusionsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListRiskExclusionsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListRiskExclusionsSecurity = {
  option1?: ListRiskExclusionsSecurityOption1 | undefined;
  option2?: ListRiskExclusionsSecurityOption2 | undefined;
};

export type ListRiskExclusionsRequest = {
  /**
   * Filter to exclusions bound to this policy. Omit to return all exclusions (global plus every policy).
   */
  riskPolicyId?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListRiskExclusionsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListRiskExclusionsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListRiskExclusionsSecurityOption1$Outbound,
  ListRiskExclusionsSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listRiskExclusionsSecurityOption1ToJSON(
  listRiskExclusionsSecurityOption1: ListRiskExclusionsSecurityOption1,
): string {
  return JSON.stringify(
    ListRiskExclusionsSecurityOption1$outboundSchema.parse(
      listRiskExclusionsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListRiskExclusionsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListRiskExclusionsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListRiskExclusionsSecurityOption2$Outbound,
  ListRiskExclusionsSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listRiskExclusionsSecurityOption2ToJSON(
  listRiskExclusionsSecurityOption2: ListRiskExclusionsSecurityOption2,
): string {
  return JSON.stringify(
    ListRiskExclusionsSecurityOption2$outboundSchema.parse(
      listRiskExclusionsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListRiskExclusionsSecurity$Outbound = {
  Option1?: ListRiskExclusionsSecurityOption1$Outbound | undefined;
  Option2?: ListRiskExclusionsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListRiskExclusionsSecurity$outboundSchema: z.ZodMiniType<
  ListRiskExclusionsSecurity$Outbound,
  ListRiskExclusionsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListRiskExclusionsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListRiskExclusionsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listRiskExclusionsSecurityToJSON(
  listRiskExclusionsSecurity: ListRiskExclusionsSecurity,
): string {
  return JSON.stringify(
    ListRiskExclusionsSecurity$outboundSchema.parse(listRiskExclusionsSecurity),
  );
}

/** @internal */
export type ListRiskExclusionsRequest$Outbound = {
  risk_policy_id?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListRiskExclusionsRequest$outboundSchema: z.ZodMiniType<
  ListRiskExclusionsRequest$Outbound,
  ListRiskExclusionsRequest
> = z.pipe(
  z.object({
    riskPolicyId: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      riskPolicyId: "risk_policy_id",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listRiskExclusionsRequestToJSON(
  listRiskExclusionsRequest: ListRiskExclusionsRequest,
): string {
  return JSON.stringify(
    ListRiskExclusionsRequest$outboundSchema.parse(listRiskExclusionsRequest),
  );
}
